import React, { useContext, useState } from "react";
import { TransButtonPrimaryWithSpinner } from "../../Atoms/Buttons";
import { ConfirmDialog, useModalState } from "../../Molecules/Dialogs";
import { Icon } from "../../Atoms/Icons";
import Moment from "react-moment";
import { patchFormSubmission } from "../../Service/restapi/formSubmissionService";
import BookingConfirmedConfetti from "../../Atoms/BookingConfirmedConfetti/BookingConfirmedConfetti";
import {Center, Space} from "@mantine/core";
import {ContactS} from "../../Service/restapi/contactService";
import {openCustomerAddressModal} from "../../Modals/CustomerAddressModal";
import {ResourceContext} from "../../Service/Context/ResourceContext";
import {
  getDocumentLanguageTranslationKey,
  getDocumentTranslator,
} from "./documentLanguage";
import { useLingui } from "@lingui/react";

export default ({ document, formSubmission, reload, resource }) => {
  const { show, toggle } = useModalState(false);
  const [loading, setLoading] = useState(false);
  const [confettiShoot, setConfettiShoot] = useState(false);
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, document.language);
  const tKey = (key) =>
    getDocumentLanguageTranslationKey(document.language, key);
    const {
        customerContact,
        setCustomerContact,
    } = useContext(ResourceContext);

    const acceptOffer = () => {
        if (!ContactS.isAddressAndPartnerDefined(customerContact)) {
            openCustomerAddressModal({
                documentType: "OFFER",
                language: document.language,
                contact: customerContact,
                onFinish: (c) => {
                    setCustomerContact(c);
                    accepted();
                },
                profileId: resource.profileId,
            });
        } else {
            toggle();
        }
    }

  function accepted() {
      setLoading(true);
      patchFormSubmission(formSubmission.id, { submitted: true })
          .then((resp) => {
              if (resp.ok) {
                  reload();
                  setConfettiShoot(true);
              }
          })
          .finally(() => {
              setLoading(false);
          });
  }

  return (
    <>
      <Space h="xl" />
      <hr />
      <div>{t("offerAcceptanceText")}</div>
      <Space h={50} />
      <div>
        {!formSubmission.lastSubmitted && (
            <Center>
                <TransButtonPrimaryWithSpinner
                    isLoading={loading}
                    disabled={loading}
                    style={{
                        height: 50,
                        alignSelf: "center",
                        marginTop: 25,
                    }}
                    onClickHandler={acceptOffer}
                    text={tKey("acceptOfferButton")}
                />
            </Center>
        )}
        <BookingConfirmedConfetti active={confettiShoot} />

        {formSubmission.lastSubmitted && (
          <div style={{ marginLeft: 20, alignSelf: "center", height: 50 }}>
            <Icon value={"BOOKED"} style={{ color: "green" }} />{" "}
            {t("acceptedAt")}{" "}
            <Moment format="L">{formSubmission.lastSubmitted}</Moment>
          </div>
        )}
        <ConfirmDialog
          text={tKey("offerConfirmText")}
          subject={tKey("offerConfirmSubject")}
          confirmText={tKey("acceptOfferButton")}
          cancelText={tKey("cancelButton")}
          open={show}
          toggle={toggle}
          handler={accepted}
        />
      </div>
    </>
  );
};
